<template>
<div id="E0-2">
    <div class="wrapper">
      <div id="content">
        <div class="inner_static">
            <div id="sheet">
              <a id="btn_back" @click="btnBackClick()"></a>
              <h1 class="tit1">図面</h1>
              <div id="sheet-disp-area"
                  @contextmenu.prevent>
                <svg xmlns="http://www.w3.org/2000/svg"
                  id="sheet2"
                  :width="svgWidth"
                  :height="svgHeight"
                  :viewBox="sheetViewBox"
                  preserveAspectRatio="xMinYMax meet"
                  @touchmove="touchMove"
                  @touchend="touchEnd"
                  @touchcancel="touchEnd"
                >

              <!-- 表題欄・外枠 -->
              <g>
                <rect
                        v-for="(rect, index) in sheetModel.titleAreaRectList"
                        :key="'titleAreaRect_' + index"
                        :x="rect.startX"
                        :y="rect.startY"
                        :width="(rect.endX - rect.startX)"
                        :height="(rect.endY - rect.startY)"
                        :stroke="rect.color ? rect.color : 'black'"
                        :fill="rect.fillColor ? rect.fillColor : 'white'"/>
                <line
                        v-for="(line, index) in sheetModel.titleAreaLineList"
                        :key="'titleAreaLine_' + index"
                        :x1="line.startX"
                        :y1="line.startY"
                        :x2="line.endX"
                        :y2="line.endY"
                        :stroke="line.color ? line.color : 'black'"
                        :stroke-width="(line.lineWeight ? line.lineWeight : 1) * svgZoomRatio + 'px'"/>
              </g>
              <!-- コンバイン構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.combineBomList"
                      :key="'combineBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.itemNameX" :font-size="bom.font">{{ bom.itemName }}</text>
                <text :x="bom.sizeX" :font-size="bom.font">{{ bom.size }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.cabinetPatternX" :font-size="bom.font">{{ bom.cabinetPattern }}</text>
                <text :x="bom.otherItemNumberX" :font-size="bom.font">{{ bom.otherItemNumber }}</text>
              </g>
              <!-- ユニット構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.unitBomList"
                      :key="'unitBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.itemNameX" :font-size="bom.font">{{ bom.itemName }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
              </g>
              <!-- パーツ構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.partsBomList"
                      :key="'partsBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.partsNameX" :font-size="bom.font">{{ bom.partsName }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.sizeX" :font-size="bom.font">{{ bom.size }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
                <text :x="bom.figureNumberX" :font-size="bom.font">{{ bom.figureNumber }}</text>
              </g>
              <!-- 金具構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.fittingBomList"
                      :key="'fittingBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.partsNameX" :font-size="bom.font">{{ bom.partsName }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
                <text :x="bom.manufactureNameX" :font-size="bom.font">{{ bom.manufactureName }}</text>
                <text :x="bom.figureNumberX" :font-size="bom.font">{{ bom.figureNumber }}</text>
              </g>

              <!-- 仕上材リスト -->
              <g
                      v-for="(bom, index) in sheetModel.finishingMaterialList"
                      :key="'finishingMaterialList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text x="10" :font-size="bom.font">{{ bom.finishingMaterial }}</text>
              </g>

              <!-- カラー設定 -->
              <g
                      v-for="(bom, index) in sheetModel.colorBomList"
                      :key="'colorBomList' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.cabinetPatternX" :font-size="bom.font">{{ bom.cabinetPattern }}</text>
                <text :x="bom.colorMaterialNameX" :font-size="bom.font">{{ bom.colorMaterialName }}</text>
              </g>
              <!-- その他カラー設定 -->
              <g
                      v-for="(bom, index) in sheetModel.otherColorBomList"
                      :key="'otherColorBomList' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.otherItemNumberX" :font-size="bom.font">{{ bom.otherItemNumber }}</text>
              </g>
              <!-- オプション構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.optionBomList"
                      :key="'optionBomList' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.itemNameX" :font-size="bom.font">{{ bom.itemName }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
              </g>

                  <!-- 図面グループ単位 -->
                  <g
                    v-for="(sheetGroup, index) in sheetModel.sheetGroupModelList"
                    :key="'sheetGroup_' + index"
                  >
                    <!-- TODO 位置調整必要かも -->
                    <!-- 図面名 -->
                    <g :transform="'translate(' + sheetGroupLBX(sheetGroup) + ',' + sheetGroupLBY(sheetGroup) + ')' ">
                      <text font-size="20" transform="scale(1,-1)">
                        {{sheetGroup.sheetTitle}}
                      </text>
                    </g>
                    <!-- 矩形 -->
                    <g>
                      <rect
                              v-for="(rect, index) in sheetGroup.rectPartsModelList"
                              :key="'rect_' + index"
                              :x="sheetGroupX(sheetGroup) + rect.startX * sheetModel.scale"
                              :y="sheetGroupY(sheetGroup) + rect.startY * sheetModel.scale"
                              :width="(rect.endX - rect.startX) * sheetModel.scale"
                              :height="(rect.endY - rect.startY) * sheetModel.scale"
                              :stroke="rect.color ? rect.color : 'black'"
                              :stroke-width="(rect.lineWeight ? rect.lineWeight : 1) * svgZoomRatio + 'px'"
                              :fill="rect.fillColor ? rect.fillColor : 'white'"/>
                    </g>
                    <!-- 線 -->
                    <g>
                      <line
                        v-for="(line, index) in sheetGroup.linePartsModelList"
                        :key="'line_' + index"
                        :x1="sheetGroupX(sheetGroup) + line.startX * sheetModel.scale"
                        :y1="sheetGroupY(sheetGroup) + line.startY * sheetModel.scale"
                        :x2="sheetGroupX(sheetGroup) + line.endX * sheetModel.scale"
                        :y2="sheetGroupY(sheetGroup) + line.endY * sheetModel.scale"
                        :z="line.z"
                        :stroke="line.color ? line.color : 'black'"
                        :stroke-width="(line.lineWeight ? line.lineWeight : 1) * svgZoomRatio + 'px'"
                        :stroke-dasharray="getDashArray(line)"/>
                    </g>
                    <!-- 可動棚線 幅の４分の３の位置に出力 -->
                    <g
                              v-for="(ms, index) in sheetGroup.movableShelfPointList"
                              :key="'ms_' + index"
                              :stroke-width="(ms.lineWeight ? ms.lineWeight : 1) * svgZoomRatio + 'px'"
                              fill="none"
                              stroke="black"
                    >
                      <path
                                :d="'M ' + (sheetGroupX(sheetGroup) + ms.x * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + ms.y * sheetModel.scale)
                                  + ' v ' + (30 * sheetModel.scale)
                                  + ' l ' + (10 * sheetModel.scale) + ' ' + (-20 * sheetModel.scale)" />
                      <path
                                :d="'M ' + (sheetGroupX(sheetGroup) + ms.x * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + ms.y * sheetModel.scale)
                                  + ' v ' + (-30 * sheetModel.scale)
                                  + ' l ' + (-10 * sheetModel.scale) + ' ' + (20 * sheetModel.scale)" />
                    </g>
                    <!-- 木目方向線 幅の４分の１か高さの４分の３の位置に出力 -->
                    <g
                              v-for="(grain, index) in sheetGroup.grainLineList"
                              :key="'grain_' + index"
                              :stroke-width="(grain.lineWeight ? grain.lineWeight : 1) * svgZoomRatio + 'px'"
                              fill="none"
                              stroke="black"
                    >
                      <line
                              :x1="sheetGroupX(sheetGroup) + grain.startX * sheetModel.scale"
                              :y1="sheetGroupY(sheetGroup) + grain.startY * sheetModel.scale"
                              :x2="sheetGroupX(sheetGroup) + grain.endX * sheetModel.scale"
                              :y2="sheetGroupY(sheetGroup) + grain.endY * sheetModel.scale"
                              z="0"
                              :stroke="grain.color ? grain.color : 'black'"
                              :stroke-width="(grain.lineWeight ? grain.lineWeight : 1) * svgZoomRatio + 'px'"
                              :stroke-dasharray="getDashArray(grain)"/>
                      <path v-if="grain.startArrow"
                                :d="'M ' + (sheetGroupX(sheetGroup) + (grain.startX + grain.arrowX) * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + (grain.startY + grain.arrowY) * sheetModel.scale)
                                  + ' l ' + (-grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)
                                  + ' l ' + (grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)"
                                  :transform="'rotate(' + grain.angle + ', ' + (sheetGroupX(sheetGroup) + grain.startX * sheetModel.scale) +', ' + (sheetGroupY(sheetGroup) + grain.startY * sheetModel.scale) + ')'"/>
                      <path v-if="grain.endArrow"
                                :d="'M ' + (sheetGroupX(sheetGroup) + (grain.endX - grain.arrowX) * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + (grain.endY + grain.arrowY) * sheetModel.scale)
                                  + ' l ' + (grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)
                                  + ' l ' + (-grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)"
                                  :transform="'rotate(' + grain.angle + ', ' + (sheetGroupX(sheetGroup) + grain.endX * sheetModel.scale) +', ' + (sheetGroupY(sheetGroup) + grain.endY * sheetModel.scale) + ')'"/>
                    </g>
                    <!-- 円 -->
                    <g>
                      <circle
                        v-for="(circle, index) in sheetGroup.circlePartsModelList"
                        :key="'circle_' + index"
                        :cx="sheetGroupX(sheetGroup) + circle.x * sheetModel.scale"
                        :cy="sheetGroupY(sheetGroup) + circle.y * sheetModel.scale"
                        :r="circle.r * sheetModel.scale"
                        :stroke="circle.color ? circle.color : 'black'"
                        fill="none"
                        :stroke-width="(circle.lineWeight ? circle.lineWeight : 1) * svgZoomRatio + 'px'"
                        :stroke-dasharray="getDashArray(circle)" />
                    </g>
                    <!-- 円弧 -->
                    <g>
                      <path
                        v-for="(arc, index) in sheetGroup.arcPartsModelList"
                        :key="'arc_' + index"
                        :d="buildPathData(sheetGroup, arc)"
                        :stroke="arc.color ? arc.color : 'black'"
                        fill="none"
                        :stroke-width="(arc.lineWeight ? arc.lineWeight : 1) * svgZoomRatio + 'px'"
                        :stroke-dasharray="getDashArray(arc)" />
                    </g>
                    <!-- 文字 -->
                    <g
                      v-for="(text, index) in sheetGroup.textPartsModelList"
                      :key="'text_' + index"
                      :transform="'translate(' + text.x * sheetModel.scale + ' ' + text.y * sheetModel.scale + ') scale(1, -1)'"
                    >
                      <text :transform="'rotate(-' + text.angle + ')'"
                          text-anchor="middle"
                          :font-size="text.font ? text.font : '12'">
                        {{ text.text }}
                      </text>
                    </g>
                    <!-- 寸法 -->
                    <g>
                      <!-- 寸法線 -->
                      <line
                        v-for="(dim, index) in sheetGroup.dimensionPartsModelList"
                        :key="'dim_' + index"
                        :x1="sheetGroupX(sheetGroup) + dim.startX * sheetModel.scale"
                        :y1="sheetGroupY(sheetGroup) + dim.startY * sheetModel.scale"
                        :x2="sheetGroupX(sheetGroup) + dim.endX * sheetModel.scale"
                        :y2="sheetGroupY(sheetGroup) + dim.endY * sheetModel.scale"
                        :stroke="dim.lineColor ? dim.lineColor : 'black'"
                        :stroke-width="(dim.lineWeight ? dim.lineWeight : 1) * svgZoomRatio + 'px'" />
                      <circle
                        v-for="(dimPoint, index) in sheetGroup.dimensionPartsModelList"
                        :key="'dimPoint_' + index"
                        :cx="sheetGroupX(sheetGroup) + dimPoint.startX * sheetModel.scale"
                        :cy="sheetGroupY(sheetGroup) + dimPoint.startY * sheetModel.scale"
                        :r="dimPoint.point * svgZoomRatio"
                        stroke="black"
                        fill="black"
                        :stroke-width="dimPoint.lineWeight ? dimPoint.lineWeight : '1px'" />

                      <!-- 文字(移動・回転を伴うためグループ化) -->
                      <!-- 横内線の文字列（寸法値）が縦内線の文字列とぶつかりにくくするため中央からサイズの４分の１ずらす -->
                      <g
                        v-for="(dimText, index) in sheetGroup.dimensionPartsModelList"
                        v-if="dimText.text"
                        :key="'dimText' + index"
                        :transform="'translate(' + (sheetGroupX(sheetGroup) + (dimText.startX + dimText.endX) / (dimText.horizontaInside ? 4 : 2) * sheetModel.scale) + ' '
                                                + (sheetGroupY(sheetGroup) + (dimText.startY + dimText.endY) / 2 * sheetModel.scale) + ') '
                                  + 'scale(1, -1)'"
                      >
                        <text
                          :transform="'translate(' + dimText.hposition + ',' + dimText.vposition + ') '
                                    + 'rotate(-' + (dimText.textAngle ? dimText.textAngle : 0) + ')'"
                          text-anchor="middle"
                          :font-size="dimText.textSize ? dimText.textSize : '7'"
                          :fill="dimText.textColor ? dimText.textColor : 'black'"
                        >
                          {{ dimText.text }}
                        </text>
                      </g>
                    </g>

                    <g>
                      <g v-for="(origin, index) in sheetGroup.originMarkerList"
                        :key="'origin_' + index"
                      >
                        <line :x1="sheetGroupX(sheetGroup) + origin.x * sheetModel.scale"
                              :y1="sheetGroupY(sheetGroup) + origin.y * sheetModel.scale"
                              :x2="sheetGroupX(sheetGroup) + origin.vertex1.x * sheetModel.scale"
                              :y2="sheetGroupY(sheetGroup) + origin.vertex1.y * sheetModel.scale"
                              stroke="black"
                              :stroke-width="svgZoomRatio + 'px'"
                        />
                        <line :x1="sheetGroupX(sheetGroup) + origin.x * sheetModel.scale"
                              :y1="sheetGroupY(sheetGroup) + origin.y * sheetModel.scale"
                              :x2="sheetGroupX(sheetGroup) + origin.vertex2.x * sheetModel.scale"
                              :y2="sheetGroupY(sheetGroup) + origin.vertex2.y * sheetModel.scale"
                              stroke="black"
                              :stroke-width="svgZoomRatio + 'px'"
                        />
                        <line :x1="sheetGroupX(sheetGroup) + origin.vertex1.x * sheetModel.scale"
                              :y1="sheetGroupY(sheetGroup) + origin.vertex1.y * sheetModel.scale"
                              :x2="sheetGroupX(sheetGroup) + origin.vertex2.x * sheetModel.scale"
                              :y2="sheetGroupY(sheetGroup) + origin.vertex2.y * sheetModel.scale"
                              stroke="black"
                              :stroke-width="svgZoomRatio + 'px'"
                        />
                      </g>
                    </g>

                    <g>
                      <line
                        v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
                        :key="'sec1_' + index"
                        :x1="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale"
                        :y1="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale"
                        :x2="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + sec.footX"
                        :y2="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + sec.footY"
                        :stroke="sec.lineColor ? dim.lineColor : 'black'"
                        :stroke-width="1 * svgZoomRatio + 'px'"
                      />
                      <line
                        v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
                        :key="'sec2_' + index"
                        :x1="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale"
                        :y1="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale"
                        :x2="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + sec.lineX"
                        :y2="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + sec.lineY"
                        :stroke="sec.lineColor ? dim.lineColor : 'black'"
                        :stroke-width="1 * svgZoomRatio + 'px'"
                      />
                      <g v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
                        :key="'secLabel_' + index"
                        :transform="'translate(' + (sheetGroupX(sheetGroup) + sec.x * sheetModel.scale) + ','
                                                  + (sheetGroupY(sheetGroup) + sec.y * sheetModel.scale) + ') '
                                  + 'scale(1, -1)'">
                        <text
                          :transform="'translate(' + sec.textXPos + ',' + sec.textYPos + ')'"
                          text-anchor="middle"
                          font-size="7"
                          fill="black">
                          {{ sec.label }}
                        </text>
                      </g>
                    </g>
                  </g>
                  <!-- 表題欄・文字列 -->
                  <g>
                    <g
                            v-for="(text, index) in sheetModel.titleAreaTextList"
                            :key="'titleAreaText_' + index"
                            :transform="'translate(' + text.x + ' ' + text.y + ') scale(1, -1)'">
                      <text
                        :transform="'rotate(-' + (text.angle ? text.angle : 0) + ')'"
                        text-anchor="start"
                        :font-size="text.font ? text.font : '12'"
                        :font-weight="text.fontWeight ? 'bolder' : 'normal'">{{ text.text }}</text>
                    </g>
                  </g>
                </svg>
              </div>
          </div>
          <!-- TODO デバッグ用 -->
          <div class="btn_area" v-if="userInfo.userDebugFlg">
            <a class="btn1" @click="debugOrderInput()">見積書画面(デバッグ用)</a>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
</div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {KG_URL, SVG_MIN_DEFAULT, KG_STORAGE_KEY, KG_SVG_ZOOM_RATIO_MIN, KG_SVG_ZOOM_INVALID_RANGE, KG_SVG_MOVE_MAGNIFICATION} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'SheetPreview',
  components: {
    'kg-loading-modal': LoadingModal
  },
  props: {
    spaceJoincd: String,
    isPreview: {
      type: Boolean,
      default: false
    },
    svgWidth: {
      type: String,
      default: '100%'
    },
    svgHeight: {
      type: String,
      default: '100%'
    },
    isShowInfo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sheetModel: {},
      selectedSheet: {
        sheetType: null,
        spaceId: null,
        subType: null
      },
      sheetTypeList: [],
      viewX: 0,
      viewY: 0,
      viewWidth: 0,
      viewHeight: 0,
      titleAreaHeight: 0,
      // 初期表示からの拡大比率、小さいほど拡大率が高い
      svgZoomRatio: 1,
      center: {
        x: 0,
        y: 0
      },
      viewBox: {
        minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0
      },
      prevPointOnCanvas: {
        x: 0,
        y: 0
      },
      drag: false,
      dragPoint: {
        x: 0,
        y: 0
      },
      userInfo: {},
      prevDistanceBetweenTouches: 0,
      documentSize: {
        x: document.documentElement.clientWidth,
        y: document.documentElement.clientHeight
      },
      // 画面上端からSVG表示位置までのy方向距離
      svgOffsetY: parseInt(window.getComputedStyle(document.documentElement).fontSize) * 1.5 + 40
    }
  },
  computed: {
    sheetViewBox: function () {
      return this.viewBox.minX + ' ' + this.viewBox.minY + ' ' + this.viewBox.width + ' ' + this.viewBox.height
    },
    /** 1pxに対するSVG単位の比率 */
    svgRatioToDocument: function () {
      return this.documentSize.x / this.viewBox.width
    }
  },
  methods: {
    getSheet: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(KG_URL.SHEET + '/get', {})
        .then(response => {
          if (response.data.data) {
            this.sheetModel = Object.assign([], response.data.data)
            this.sheetTypeList = response.data.data.sheetTypeList
            this.viewWidth = this.sheetModel.sheetWidth
            this.viewHeight = this.sheetModel.sheetHeight
            this.titleAreaHeight = this.sheetModel.titleAreaHeight
            this.viewBox.minX = 0
            this.viewBox.minY = 0
            this.viewBox.width = this.viewWidth
            this.viewBox.height = this.viewHeight
            this.svgZoomRatio = 1
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.$emit('showModal')
        })
    },
    sheetGroupX: function (sheetGroup) {
      return sheetGroup.startX - (sheetGroup.width / 2) * this.sheetModel.scale
    },
    sheetGroupY: function (sheetGroup) {
      return sheetGroup.startY - (sheetGroup.height / 2) * this.sheetModel.scale
    },
    sheetGroupLBX: function (sheetGroup) {
      return sheetGroup.startX - sheetGroup.areaWidth / 2
    },
    sheetGroupLBY: function (sheetGroup) {
      return sheetGroup.startY - sheetGroup.areaHeight / 2
    },
    buildPathData: function (sheetGroup, arc) {
      let scale = this.sheetModel.scale
      let x = this.sheetGroupX(sheetGroup)
      let y = this.sheetGroupY(sheetGroup)
      let d = ''
      d += 'M '
      d += (x + (arc.startX) * scale) + ' '
      d += (y + (arc.startY) * scale) + ' '
      d += 'A '
      d += arc.rw * scale + ' '
      d += arc.rh * scale + ' '
      d += '0 '
      d += (arc.longer ? '1' : '0') + ' '
      d += (arc.cw ? '1' : '0') + ' '
      d += (x + (arc.endX) * scale) + ' '
      d += (y + (arc.endY) * scale)
      return d
    },
    getDashArray: function (parts) {
      let dashed = 3
      if (parts.ltype === 'DOT') {
        dashed *= this.svgZoomRatio
        return dashed + ' ' + dashed + ' '
      }
      return ''
    },
    convertSectionPoints: function (sectionList) {
      return []
    },
    debugOrderInput: function () {
      this.$router.push({
        name: 'KgOrderInput'
      })
    },
    btnBackClick: function () {
      /* eslint-disable */
      Unity.call('kagull_app?sheet=close')
      this.resetCanvas()
    },
    touchMove: function (event) {
      event.preventDefault()
      const touches = event.changedTouches
      // 2本指での操作のみ処理
      if (touches.length == 2) {
        const x1 = touches[0].clientX
        const y1 = touches[0].clientY
        const x2 = touches[1].clientX
        const y2 = touches[1].clientY
        const clientCenter = {
          x: (x1 + x2) / 2,
          y: (y1 + y2) / 2
        }
        this.setCurrentCenterOnCanvas(clientCenter)
        this.dragCanvas(clientCenter)
        this.zoomCanvas(x1, y1, x2, y2)
      }
    },
    /** clientCenterをキャンバス上での座標に変換してセット */
    setCurrentCenterOnCanvas: function (clientCenter) {
      this.currentCenterOnCanvas = {
        x: clientCenter.x / this.svgRatioToDocument + this.viewBox.minX,
        y: this.viewBox.height + this.viewBox.minY - (clientCenter.y - this.svgOffsetY) / this.svgRatioToDocument
      }
    },
    dragCanvas: function (clientCenter) {
      if (this.dragPoint.x == 0 && this.dragPoint.y == 0) {
        this.dragPoint = {...clientCenter}
        return
      }

      // 移動幅増大のためにKG_SVG_MOVE_MAGNIFICATIONをかける
      const moveX = (this.dragPoint.x - clientCenter.x) * this.svgZoomRatio * KG_SVG_MOVE_MAGNIFICATION
      const moveY = (this.dragPoint.y - clientCenter.y) * this.svgZoomRatio * KG_SVG_MOVE_MAGNIFICATION

      this.viewBox.minX += moveX
      this.viewBox.minY -= moveY

      this.setViewBox(this.viewBox.minX + moveX, this.viewBox.minY - moveY, this.viewBox.width, this.viewBox.height)
      this.dragPoint = {...clientCenter}
    },
    zoomCanvas: function (x1, y1, x2, y2) {
      const distanceBetweenTouches = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
      if (this.prevDistanceBetweenTouches == 0) {
        this.prevDistanceBetweenTouches = distanceBetweenTouches
        return
      }
      const ratioToPrevSvg = Math.round(this.prevDistanceBetweenTouches / distanceBetweenTouches * 100) / 100
      // 微小な指間距離変化は無視
      if (KG_SVG_ZOOM_INVALID_RANGE.min < ratioToPrevSvg && ratioToPrevSvg < KG_SVG_ZOOM_INVALID_RANGE.max) return
      const prevSvgZoomRatio = this.svgZoomRatio
      this.svgZoomRatio *= ratioToPrevSvg
      // 拡大率を制限
      if (this.svgZoomRatio < KG_SVG_ZOOM_RATIO_MIN) {
        this.svgZoomRatio = KG_SVG_ZOOM_RATIO_MIN
        return
      }
      // 原寸以下には縮小しない
      if (this.svgZoomRatio >= 1) {
        this.resetCanvas()
        return
      }

      // 指の中間位置を基準にズーム
      const width = Math.round(this.viewWidth * this.svgZoomRatio)
      const height = Math.round(this.viewHeight * this.svgZoomRatio)
      const {x, y} = this.currentCenterOnCanvas
      const tmpZoomRatio = this.svgZoomRatio / prevSvgZoomRatio
      const newMinX = x - (x - this.viewBox.minX) * tmpZoomRatio
      const newMinY = y - (y - this.viewBox.minY) * tmpZoomRatio

      this.setViewBox(newMinX, newMinY, width, height)
      this.prevDistanceBetweenTouches = distanceBetweenTouches
    },
    /** SVGのビューボックスに値を設定する */
    setViewBox: function (minX, minY, width, height) {
      this.viewBox.width = width
      this.viewBox.height = height
      if (minX < 0) {
        this.viewBox.minX = 0
      } else if (this.viewWidth < minX + width) {
        this.viewBox.minX = this.viewWidth - width
      } else {
        this.viewBox.minX = minX
      }

      if (this.svgZoomRatio === 1) {
        this.viewBox.minY = 0
      } else if (minY < -this.titleAreaHeight / 4 / this.svgZoomRatio) {
        this.viewBox.minY = -this.titleAreaHeight / 4 / this.svgZoomRatio
      } else if (this.viewHeight < minY + height) {
        this.viewBox.minY = this.viewHeight - height
      } else {
        this.viewBox.minY = minY
      }
    },
    /** タッチ終了時にリセット */
    touchEnd: function () {
      this.dragPoint.x = 0
      this.dragPoint.y = 0
      this.prevDistanceBetweenTouches = 0
    },
    /** 図面の表示をリセット */
    resetCanvas: function () {
      this.viewBox.minX = 0
      this.viewBox.minY = 0
      this.viewBox.width = this.viewWidth
      this.viewBox.height = this.viewHeight
      this.svgZoomRatio = 1
    }
  },
  watch: {
    $route (to, from) {
      // Unityから再遷移すると再描画されないため、パラメータのタイムスタンプの変更を検知して図面の再取得をする
      this.getSheet()
    }
  },
  mounted () {
    // 図面情報の取得
    this.getSheet()
  },
  created: function () {
    this.userInfo = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
#content {
  height: 600px;
}
.inner_static {
  height: 100%;
}
#sheet {
  height: 100%;
}
#sheet-disp-area {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/main/js/kagull/pages/SheetPreview.vue